const handTrackText = `This project was my introduction into TensorFlow's machine learning library.
I wanted to make a simple front-end tool created with React.js so that any user would have the ability to track their fingers and visualize the data points.
I'm planning on using this project as a spring board to creating more complex machine learning projects.`


export default handTrackText